import styled from "styled-components"

export const Select = styled.select`
  font-size: 1em;
  padding: 0.7em;

  border: none;
`;